import { isRejectedWithValue } from "@reduxjs/toolkit";
import httpStatus from "http-status";
import { logoutUser } from "src/features/auth/store/actions/auth/login";
export const rtkErrorHandler = (store) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        const { payload: { status, data } } = action;
        if (status === httpStatus.UNAUTHORIZED && ((data === null || data === void 0 ? void 0 : data.name) === "NoTokenError" || (data === null || data === void 0 ? void 0 : data.name) === "BadTokenError")) {
            store.dispatch(logoutUser());
        }
    }
    return next(action);
};
export default rtkErrorHandler;
